<mat-form-field
  appearance="outline"
  [ngClass]="{ 'mat-form-field-readonly': readonly }"
>
  <mat-label [ngClass]="{ 'label-text-readonly': readonly }">{{
    "municipality" | translate
  }}</mat-label>
  <input
    type="text"
    matInput
    [formControl]="control"
    [matAutocomplete]="auto"
    [required]="required"
    [readonly]="readonly"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="onMunicipalitySelected($event)"
    [displayWith]="displayMunicipality"
  >
    <mat-option
      *ngFor="let municipality of filteredMunicipalities$ | async"
      [value]="municipality.name"
    >
      {{ municipality.name }} ({{ municipality.province }})
    </mat-option>
  </mat-autocomplete>
  <mat-error *ngIf="control.invalid && control.touched && required">
    {{ "municipality-required" | translate }}
  </mat-error>
</mat-form-field>
